module.exports = WHATWGFetch;